import { useMemo } from 'react';
import capitalize from 'lodash/capitalize';
import { GridColDef, GridValueFormatterParams } from '@mui/x-data-grid';
import { AccountPolicyInterface } from '../../../types/policy';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import DataTile from '../DataTile';
import ProgramDataGrid from './ProgramDataGrid';
import { useAppSelector } from '../../../store/hook';

type AccountPolicyTable = {
  category: string;
  value_type: string;
  value: string | number;
};

const getAccountPolicyColumns = (): GridColDef<AccountPolicyTable>[] => [
  {
    field: 'category',
    headerName: 'Transaction Category',
    flex: 1,
    sortable: false,
    minWidth: 180,
  },
  {
    field: 'value_type',
    headerName: 'Value Type',
    flex: 1,
    sortable: false,
    minWidth: 180,
    valueFormatter: (params: GridValueFormatterParams<string>) =>
      capitalize(params.value),
  },
  {
    field: 'value',
    headerName: 'Value',
    flex: 1,
    sortable: false,
    minWidth: 180,
  },
];
function ViewAccountPolicy() {
  const columnsRef = useMemo(() => getAccountPolicyColumns(), []);

  const activePolicy = useAppSelector(
    (state) => state.programManagement.activePolicy
  ) as AccountPolicyInterface;

  const tableData: AccountPolicyTable[] = useMemo(() => {
    if (!activePolicy) {
      return [];
    }
    const data: AccountPolicyTable[] = [
      {
        category: 'Overlimit',
        value_type: activePolicy.overlimit.value_type,
        value: activePolicy.overlimit.value,
      },
      {
        category: 'Payment Deviation',
        value_type: activePolicy.payment_deviation.value_type,
        value: activePolicy.payment_deviation.value,
      },
      {
        category: 'Cash Limit',
        value_type: activePolicy.cash_limit.value_type,
        value: activePolicy.cash_limit.value,
      },
      {
        category: 'Charge Off',
        value_type: 'Days',
        value: activePolicy.days_to_mark_account_charge_off,
      },
      {
        category: 'Write Off',
        value_type: 'Days',
        value: activePolicy.days_to_mark_account_write_off,
      },
    ];
    return data;
  }, [activePolicy]);

  if (!activePolicy) {
    return null;
  }

  return (
    <Box
      sx={{
        p: {
          xs: 1,
          sm: 3,
        },
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={6} sm={4}>
          <DataTile
            title="Grace Period"
            value={`${activePolicy.grace_period ?? '-'}`}
          />
        </Grid>
      </Grid>
      <ProgramDataGrid
        data={tableData}
        columns={columnsRef}
        idColumn={'category'}
      />
    </Box>
  );
}

export default ViewAccountPolicy;
